import { render, staticRenderFns } from "./SbPanel.vue?vue&type=template&id=ec0ddeaa&"
import script from "./SbPanel.vue?vue&type=script&lang=js&"
export * from "./SbPanel.vue?vue&type=script&lang=js&"
import style0 from "./SbPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GTHB06-CV-01\\_work\\sb\\sb\\mvc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec0ddeaa')) {
      api.createRecord('ec0ddeaa', component.options)
    } else {
      api.reload('ec0ddeaa', component.options)
    }
    module.hot.accept("./SbPanel.vue?vue&type=template&id=ec0ddeaa&", function () {
      api.rerender('ec0ddeaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "SPHEREboardMVC/wwwroot/vue/components/SbPanel.vue"
export default component.exports